<template lang="html">
  <div class="question-container">
    <div class="title--txt">
      CONGRATULATIONS!
    </div>
    <div class="welcome-txt">
      <div class="stars-display">
        <template v-for="i in karmaPoints">
          <v-btn icon><i class="star-icon"></i></v-btn>
        </template>
      </div>
      <div class="py-4 karma--text">
        You have received {{ karmaPoints }} KARMA points for completing this effort. What would you like to do next?
      </div>
    </div>
    <div class="btn-container">
      <div class="browse-btn-div">
        <v-btn large class="browse-task-button white--text" :to="{name: 'Tasks', query: { browse_id: 1 }}">Browse Effort</v-btn>
      </div>
      <div class="profile-btn-div">
        <v-btn flat small class="edit" :to="{name: 'UserProfile', params: {id: userId}}">
          <span>
            View Your Profile
          </span>
        </v-btn>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  computed: {
    userId() {
      return this.$store.getters['auth/userId'];
    },
    karmaPoints() {
      return this.$store.getters['completionQuestions/karmaPoints'];
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";
#app {
  input {
    width: 100%;
  }
  .karma--text {
    text-align: center;
    font-size:16px;
    color: black;
  }

  .browse-task-button {
    border-radius: 24px;
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px;
    position: relative;
  }
  .browse-btn-div {
    flex-grow: 2;
  }

  .title--txt {
    margin-top: 30px;
  }
  .welcome-txt {
    flex-grow: 9;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .btn-container {
    flex-grow: 2;
  }

  @media only screen and (min-width:500px) {
    .btn-container {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/QuestionThanks.vue